import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Accordion, AccordionHeading } from '@yuno/sdk-web-core/dist/ui'

export const OrderContainer = styled.article``

export const Heading = styled.h1`
  ${({ theme }) => css({ ...theme.typographys.xl.bold })}
`

export const Instructions = styled.p`
  ${({ theme }) => css({ ...theme.typographys.base.regular })}
  color: ${({ theme }) => theme.colors.grey[4]};
`

export const OrderDetailTitleContainer = styled.div`
  display: flex;
  width: 100%;
`

export const OrderDetailTitleLeftContent = styled.div`
  flex-grow: 1;
  justify-content: left;
  display: flex;
  align-items: center;

  > span {
    ${({ theme }) => css({ ...theme.typographys.small.bold })}
  }
`

export const OrderDetailTitleRightContent = styled.div`
  flex-grow: 1;
  justify-content: right;
  display: flex;
  align-items: center;
  padding-right: 30px;

  > span {
    ${({ theme }) => css({ ...theme.typographys.small.regular })}
    color: ${({ theme }) => theme.colors.grey[5]};
  }
`

export const OrderAccordion = styled(Accordion)`
  background-color: ${({ theme }) => theme.colors.neutrals.w};
  padding: 16px;
  border-radius: ${({ theme }) => theme.spacers.l};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  margin-top: 52px;

  .Yuno-accordion__heading-title {
    padding: 0;
    border: none;
  }

  .close .Yuno-accordion__heading-title::after {
    right: 8px;
  }

  .open .Yuno-accordion__heading-title::after {
    right: 10px;
  }
`

export const OrderDetailContentContainer = styled.div`
  display: flex;
  margin-top: 24px;
`

export const OrderDetailContentLeftContent = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  flex-grow: 1;
  gap: 16px;
`

export const OrderDetailContentRightContent = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
`

export const OrderDetailContentImage = styled.div<{ image: string }>`
  flex-grow: 0;
  width: 48px;
  height: 48px;
  background-image: url(${({ image }) => image});
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 4px;
`

export const OrderDetailContentName = styled.div`
  ${({ theme }) => css({ ...theme.typographys.small.regular })}
  flex-grow: 1;
`

export const OrderDetailContentPrice = styled.div`
  ${({ theme }) => css({ ...theme.typographys.small.regular })}
`

export const OrderTotalWrapper = styled.div`
  padding: 16px 0;
`

export const OrderTotalContainer = styled.div`
  margin-top: 24px;
`

const OrderTotalItem = styled.div`
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[2]};

  span {
    flex-grow: 0;
  }
`

export const OrderTotalSubtotal = styled(OrderTotalItem)`
  span {
    ${({ theme }) => css({ ...theme.typographys.small.regular })}
  }
`

export const OrderTotalShipping = styled(OrderTotalItem)`
  span {
    ${({ theme }) => css({ ...theme.typographys.small.regular })}
    color: ${({ theme }) => theme.colors.grey[5]};
  }
`

export const OrderTotalDue = styled(OrderTotalSubtotal)<{
  hasProducts: boolean
}>`
  span:last-child {
    ${({ theme }) => css({ ...theme.typographys.m.bold })}
  }

  ${({ hasProducts, theme }) =>
    !hasProducts &&
    `
    border-top: none;
    flex-direction: column;
  
    span {
      text-align: center;
    }

    span:last-child {
      font-size: ${theme.typographys['3xl'].bold.fontSize};
      margin-top: 8px;
    }
  `}
`

export const NumberOfArt = styled.div`
  ${({ theme }) => css(theme.typographys.tiny.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};
`

export const DefaultImageContainer = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.grey[1]};
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 48px;

  > svg {
    flex-grow: 0;
  }
`

export const OrderDetailPurchaseItem = styled.div`
  margin-top: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[2]};

  &:last-child {
    border-bottom: none;
  }
`

export const OrderDetailPurchaseTitle = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;

  span:first-of-type {
    flex-grow: 1;
  }
`

export const OrderDetailPurchaseDetails = styled.div`
  display: flex;
  align-items: start;
  padding: 8px;
`

export const OrderDetailPurchaseDetailsArrival = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;

  span:nth-child(2) {
    margin-top: 10px;
  }
`

export const OrderDetailPurchaseTitleSeparator = styled.div`
  height: 16px;
  border-right: 1px solid ${({ theme }) => theme.colors.grey[4]};
  padding-left: 10px;
  margin-right: 10px;
`

export const OrderDetailPurchaseTitleSeparatorH = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[2]};
  margin: 8px 12px 0 12px;
  flex-grow: 1;
`

export const OrderDetailPurchaseSpanRegular = styled.span`
  ${({ theme }) => css(theme.typographys.tiny.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};
`

export const OrderDetailPurchaseSpanBold = styled.span`
  ${({ theme }) => css(theme.typographys.tiny.bold)};
  color: ${({ theme }) => theme.colors.grey[5]};
`

export const AccordionHeadingPurchase = styled(AccordionHeading)`
  button {
    border: none;
    background-color: transparent;
    padding: 8px 0;
    ${({ theme }) => css(theme.typographys.tiny.bold)};
    color: ${({ theme }) => theme.colors.grey[5]};

    &::after {
      right: 0;
    }

    &[aria-expanded='true'] {
      &::after {
        right: 2px;
      }
    }
  }
`

export const OrderTotalPurchase = styled.div<{ hasProducts: boolean }>`
  ${({ hasProducts }) =>
    hasProducts &&
    `
    display: flex;
    justify-content: end;
  `}
`

export const OrderTotalPurchaseContainer = styled.div<{ hasProducts: boolean }>`
  ${({ hasProducts }) =>
    hasProducts &&
    `
    width: 366px;
    padding-right: 16px;
  `}
`
